module.exports = __webpack_public_path__ + "media/images/icons/trash-53420c5653e758a846b09cae1b85141f.svg";